import usePrivateAxios from '@/common/api/usePrivateAxios'
import { PermissionData } from '@/common/types/permissions';
import { UseQueryResult, useQuery } from '@tanstack/react-query'

interface UsePermissionsMineProps {
  staleTime?: number;
  enabled?: boolean;
}

const usePermissionsMine: (props: UsePermissionsMineProps) => UseQueryResult<PermissionData[], unknown> = ({ staleTime, enabled }) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: PermissionData[] } }, unknown, PermissionData[]>({
    queryKey: ['permissionsMine'],
    queryFn: () => privateAxios.get(`/permissions/mine`),
    select: (data) => data?.data?.data,
    staleTime,
    enabled,
  });
}

export default usePermissionsMine;
